import { useDispatch } from 'react-redux';

import ListMenu from "../Commons/ListMenu";
import { setCurrentNavigation } from "../../slices/navigationSlice";
import useMount from '../../hooks/useMount';

import "./AdminTrouble.css";

const AdminTroublePage = (props) =>
{

  //Redux
  const Dispatch = useDispatch();

  useMount(() =>
  {
    Dispatch(setCurrentNavigation("Ad_Trouble"));
  }, []);

  return (
    <div>
      <div className="admintrouble_text">
        Admin Troubleshoot
      </div>
      <div className="admintrouble_menu_cont">
        <ListMenu />
      </div>
    </div>
  )

};

export default AdminTroublePage;